import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import TooltipIcon from "../../common/TooltipIcon";
import { SyncOutlined } from "@ant-design/icons";
import GroupSyncTypeSelector from "./GroupSyncTypeSelector";
import { selectGroupById, patchComputingGroup } from "../../../actions/api";
import { successAction, errorAction, types as at } from "@authzsvc/api-lib";
import { showErrorNotification, showSuccessNotification } from "../../../util";
import EGroupWarning from "../EGroupWarning";
import { Card, Typography, Skeleton } from "antd";

const GroupSyncTypePanel = ({
  selectedGroup,
  canManageGroup,
  // methods
  selectGroupById,
  patchComputingGroup,
}) => {
  const [loading, setLoading] = useState(false);

  const handleGroupTypeChange = async (groupType) => {
    if (
      (groupType === "SlaveWithPlaceholders" || groupType === "Slave") &&
      selectedGroup.syncType === "Master" &&
      selectedGroup.dynamic
    ) {
      showErrorNotification(
        "Cannot convert a primary dynamic group to replica!",
        "A dynamic group cannot be converted to a replica group."
      );
    } else {
      setLoading(true);
      const groupId = selectedGroup.id;
      const result = await patchComputingGroup(groupId, [
        {
          value: groupType,
          path: "/syncType",
          op: "replace",
        },
      ]);
      if (result.type === successAction(at.PATCH_GROUP_BY_ID)) {
        showSuccessNotification("Successfully updated group", "");
      } else if (result.type === errorAction(at.PATCH_GROUP_BY_ID)) {
        showErrorNotification(
          result.payload.title,
          result.payload.data.message
        );
      }
      await selectGroupById(groupId);
      setLoading(false);
    }
  };

  return (
    <>
      <EGroupWarning
        selectedGroup={selectedGroup}
        canManageGroup={canManageGroup}
        showSyncMessage={true}
      />
      <Card
        title={
          <Typography.Title level={4} style={{ margin: 0 }}>
            <SyncOutlined style={{ marginRight: 8, color: "#bfbfbf" }} />
            Group synchronization type
            <TooltipIcon
              size={16}
              title="The type of synchronization this group is using. Replica groups are read-only and synced from E-Groups, while primary groups are synchronized to E-Groups."
            />
          </Typography.Title>
        }
        aria-label="Group synchronization type panel"
      >
        {loading ? (
          <Skeleton active paragraph={{ rows: 3 }} />
        ) : (
          selectedGroup &&
          selectedGroup.id && (
            <GroupSyncTypeSelector
              loading={loading}
              onChange={handleGroupTypeChange}
              groupType={selectedGroup.syncType}
              canManageGroup={canManageGroup}
            />
          )
        )}
      </Card>
    </>
  );
};

GroupSyncTypePanel.propTypes = {
  selectedGroup: PropTypes.object.isRequired,
  selectGroupById: PropTypes.func.isRequired,
  patchComputingGroup: PropTypes.func.isRequired,
};

export default connect(
  (state) => ({
    selectedGroup: state.groups.selectedGroup,
  }),
  { selectGroupById, patchComputingGroup }
)(GroupSyncTypePanel);
